import { render, staticRenderFns } from "./CardViewer.vue?vue&type=template&id=0125cc88&"
import script from "./CardViewer.vue?vue&type=script&lang=js&"
export * from "./CardViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports